import { atom } from 'recoil';

const EMPTY_ADMIN = {
  user_id: '',
  f_name: '',
  l_name: '',
  email: '',
  state: '',
  role: '',
  logged_in: false,
  impersonating: false
};

// Optimistic hydration from localStorage. finalizeAdminLogin writes the
// admin payload here on successful login (TOTP-confirmed or freshly enrolled).
// Without this, PrivateRoutes (type='admin') sees logged_in=false on first
// render after a reload and bounces to /admin/login synchronously — Utility's
// async getAdminData → check_token can't complete in time to prevent it.
// Utility still runs check_token afterwards; if the server session is
// actually invalid it clears localStorage and re-redirects.
const hydrateAdmin = () => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return EMPTY_ADMIN;
    const raw = window.localStorage.getItem('admin-state');
    if (!raw) return EMPTY_ADMIN;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return EMPTY_ADMIN;
    return { ...EMPTY_ADMIN, ...parsed, logged_in: true };
  } catch {
    return EMPTY_ADMIN;
  }
};

export const current_admin = atom({
  key: 'current_admin',
  default: hydrateAdmin()
});

export default { current_admin };
